import type {ContaVm} from "@/modules/extrato/type/conta.type";
import * as zod from "zod";

export interface SolicitacaoVm {
    id: string,
    numeroSolicitacao: number,
    uniqueId: string,
    descricao:string,
    status: number,
    statusDesricao: string,
    tipoSolicitacao: number,
    tipoSolicitacaoDescricao: string,
    dataAte: Date,
    dataAteFormatada: string,
    dataDe: Date,
    dataDeFormatada: string, 
    criadoEm: Date,
    criadoEmFormatado: string,
    conta: ContaVm

}

export function dataAsSolicitacaoVm(data: any): SolicitacaoVm {
    return data as SolicitacaoVm;
}

export const zodSolicitacaoVm = zod.object({
    id: zod.string(),
    uniqueId: zod.string()
}, {message: "Selecione uma solicitação"}).refine((val) => val != null);


export interface SolicitacaoLogVm {
    descricao: string,
    status: number,
    statusDesricao: string,
    criadoEmFormatado: string,
}

export function dataAsSolicitacaoLogVm(data: any): SolicitacaoLogVm {
    return data as SolicitacaoLogVm;
}